<template>
  <div v-if="article">
    <div class="buttons" style="margin-bottom: 3px">
      <button class="button" v-on:click="$router.push('/')">
        <span class="icon">
          <i class="fas fa-home"></i>
        </span>
        <span>Home</span>
      </button>
    </div>
    <div class="columns is-variable is-2 is-multiline is-mobile">
      <div class="column is-one-third-desktop is-full-tablet is-full-mobile">
        <div class="card summary">
          <v-lazy-image
              :src="article.image || 'https://via.placeholder.com/500.png?text=' + encodeURIComponent(article.title)"
              src-placeholder="https://www.brownweinraub.com/wp-content/uploads/2017/09/placeholder.jpg"
          />
        </div>
      </div>
      <div class="column is-two-thipard-desktop">
        <div class="card summary">
          <h1>{{ article.title }}</h1>
          <span>By {{ article.author }}</span>
          <p>{{ article.text }}</p>
          <button class="button" v-on:click="$impressions.externalClick('app_article_read_more', article.source)">Read More</button>
        </div>
      </div>
      <div v-if="this.articles" class="columns is-variable is-2 is-multiline is-mobile">
        <div class="column is-one-quarter-desktop">
          <CardLink :data="this.articles[0]" size="medium" type="news"></CardLink>
          <CardLink :data="this.articles[1]" size="medium" type="news"></CardLink>
        </div>
        <div class="column is-one-quarter-desktop">
          <CardLink :data="this.articles[2]" size="medium" type="news"></CardLink>
          <CardLink :data="this.articles[3]" size="medium" type="news"></CardLink>
        </div>
        <div class="column is-one-quarter-desktop">
          <CardLink :data="this.articles[4]" size="medium" type="news"></CardLink>
          <CardLink :data="this.articles[5]" size="medium" type="news"></CardLink>
        </div>
        <div class="column is-one-quarter-desktop">
          <CardLink :data="this.articles[6]" size="medium" type="news"></CardLink>
          <CardLink :data="this.articles[7]" size="medium" type="news"></CardLink>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import "../styles/Article"
</style>

<script>
import VLazyImage from "v-lazy-image";
import CardLink from "../components/CardLink";

export default {
  components: {CardLink, VLazyImage },
  methods: {
    async onLoad() {
      this.article = await this.$news.GetArticle(this.$route.params.source, this.$route.params.title)
      if (this.article === undefined)
        await this.$router.push('/news');
      document.title = this.article.title + ' - My Recipe Finder';

      let articles = await this.$news.GetLatest();
      articles.findIndex(obj => obj.title === this.$route.params.title);
      articles.splice(articles.findIndex(obj => obj.title === this.$route.params.title), 1);
      articles = articles.sort(() => 0.5 - Math.random()).slice(0, 8);
      this.articles = articles;
    }
  },
  watch: {
    '$route.params.title'() {
      this.onLoad();
    }
  },
  async created() {
    await this.onLoad()
  },
  data() {
    return {
      article: undefined,
      articles: undefined,
    }
  }
}
</script>